/**
 * EN-3907: display formats for the range picker, keyed off `navigator.language`.
 *
 * These are the same locales and the same orders the react-datepicker version
 * carried, re-expressed in dayjs tokens (antd parses and formats with dayjs).
 * The locale source is deliberately left as `navigator.language` rather than
 * i18next: switching it changes which format every filter bar shows and is a
 * behaviour change this bug fix has no mandate for.
 */
export const DATE_RANGE_FORMATS: Record<string, string> = {
  "da-DK": "DD-MM-YYYY",
  "de-DE": "DD.MM.YYYY",
  "el-GR": "D/M/YYYY",
  "en-GB": "DD/MM/YYYY",
  "en-IE": "DD/MM/YYYY",
  "en-US": "M/D/YYYY",
  "es-ES": "DD/MM/YYYY",
  "fr-FR": "DD/MM/YYYY",
  "it-IT": "DD/MM/YYYY",
  "nl-NL": "D-M-YYYY",
};

export const FALLBACK_DATE_RANGE_FORMAT = "DD/MM/YYYY";

export function getDateRangeFormat(locale?: string): string {
  if (!locale) {
    return FALLBACK_DATE_RANGE_FORMAT;
  }

  return DATE_RANGE_FORMATS[locale] ?? FALLBACK_DATE_RANGE_FORMAT;
}

/**
 * The placeholder the user sees before typing. The old component showed the
 * format in upper case ("DD/MM/YYYY"), which the dayjs tokens already are.
 */
export function getDateRangePlaceholder(locale?: string): [string, string] {
  const format = getDateRangeFormat(locale);

  return [format, format];
}
